import React from 'react';
import { Box, Grid } from '@mui/material';

import {
  Divider,
  InfoField,
  InfoFieldProps,
  LinearProgress,
  Typography,
  Card,
  CardContent,
} from '@occc/ui-design-system';
import { Map } from '@occc-app/design-system';
import { SiteSystemDetailsFragment } from '@occc/graphql';

import { DateTimeFormatTZ, formatDateTimeTZ, parseDate } from '../../../../lib/date';

// TODO change props structure

interface ILocationSiteInfoProps {
  identifier: string;
  merchantId?: string;
  lastConnection?: string;
  siteDetails?: SiteSystemDetailsFragment;
  timezone: string;
  loading: boolean;
}

const InfoFieldItem: React.FC<InfoFieldProps> = (props) => {
  return (
    <Grid item sm={3}>
      <InfoField {...props} />
    </Grid>
  );
};

const LocationSiteInfo: React.FC<ILocationSiteInfoProps> = ({
  identifier,
  lastConnection,
  siteDetails,
  timezone,
  loading,
}) => {
  return (
    <>
      <Card>
        <CardContent>
          {loading && <LinearProgress />}
          <Typography variant='h6'>Site Info</Typography>
          {lastConnection && (
            <Typography paragraph mt={2}>
              {`The last message was received on ${formatDateTimeTZ(
                parseDate(lastConnection),
                timezone,
                DateTimeFormatTZ.DateTimeWithShortTimeZone,
              )}`}
            </Typography>
          )}

          <Grid container spacing={2} pb={1} pt={3}>
            <InfoFieldItem label='Site Address' value={siteDetails?.siteAddress} />
            <InfoFieldItem label='Site Name' value={siteDetails?.siteName} />
            <InfoFieldItem label='Site ID' value={identifier} />
            <InfoFieldItem label='Welcome Message' value={siteDetails?.welcomeMsg} />
          </Grid>
          <Divider />
          <Grid container spacing={2} pb={1} pt={3}>
            <InfoFieldItem label='Mobile Version' value={siteDetails?.mobileVersion} />
            <InfoFieldItem
              label='Site Mobile Active'
              value={siteDetails?.mobileActive ? 'True' : 'False'}
            />
            <InfoFieldItem
              label='Partial Auth Allowed'
              value={siteDetails?.partialAuthAllowed ? 'True' : 'False'}
            />
            <InfoFieldItem label='Pump Timeout' value={siteDetails?.pumpTimeout} />
          </Grid>
          <Divider />
          <Grid container spacing={2} pb={1} pt={3}>
            <InfoFieldItem label='Latitude' value={siteDetails?.latitude} />
            <InfoFieldItem label='Longitude' value={siteDetails?.longitude} />
          </Grid>
        </CardContent>
      </Card>
      {siteDetails && siteDetails.latitude && siteDetails.longitude ? (
        <Box my={1}>
          <Map longitude={siteDetails.longitude} latitude={siteDetails.latitude} withBorder />
        </Box>
      ) : null}
    </>
  );
};

export default LocationSiteInfo;
